module.exports = __webpack_public_path__ + "static/media/C-D-logo.6197c4ed.png";